import { Component, Vue, Watch } from 'vue-property-decorator'
import vSelect from 'vue-select'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faTrashAlt,
	faEdit,
	faCirclePlus,
	faLink,
} from '@fortawesome/free-solid-svg-icons'

import Loader from '@/components/Loader/index.vue'
import CreateModal from './CreateModal/index.vue'
import EditModal from './EditModal/index.vue'

import api from '@/helpers/fetch'
import Fuse from 'fuse.js'
let fuse = new Fuse([], {})

library.add(faTrashAlt, faEdit, faCirclePlus, faLink)

@Component({
	components: {
		Loader,
		vSelect,
		CreateModal,
		EditModal,
	},
})
export default class ContentLaminas extends Vue {
	loading = false
	modalLoading = false
	savingTag = false
	filter = ''
	selectedLamina = 0

	options = {
		laminas: [] as Array<any>,
		tags: [] as Array<any>,
	}

	form = {
		id: '',
		title: '',
		desc: '',
		url: '',
		content_tags: [] as Array<any>,
	}

	formTags = {
		id: '',
		tags: [] as Array<any>,
		tag: '',
	}

	get filteredOptions() {
		return this.filter.length
			? fuse.search(this.filter).map(({ item }) => item)
			: this.options.laminas
	}

	fuseSearch(options, search) {
		const fuse = new Fuse(options, {
			keys: ['name'],
			shouldSort: true,
			ignoreLocation: true,
		})

		return search.length
			? fuse.search(search).map(({ item }) => item)
			: options
	}

	async loadContentLaminas() {
		this.loading = true
		const res = await api.get('/api/blogging/content-laminas')
		this.loading = false
		this.options.laminas.length = 0
		this.options.laminas.push(
			...res.data.map((option) => {
				Object.assign(option, { loading: false })
				option.content_tags = option.content_tags.map((tagMap) => {
					Object.assign(tagMap, { loading: false })
					return tagMap
				})
				return option
			}),
		)
		// @ts-ignore
		fuse = new Fuse(this.options.laminas, {
			keys: ['title'],
		})
	}

	async loadContentTags() {
		this.loading = true
		const res = await api.get('/api/blogging/content-tags')
		this.loading = false
		this.options.tags.length = 0
		this.options.tags.push(...res.data)
	}

	clearForm() {
		this.form.id = ''
		this.form.title = ''
		this.form.desc = ''
		this.form.url = ''

		this.formTags.id = ''
		this.formTags.tag = ''
		this.formTags.tags = []
		this.modalLoading = false
	}

	openEdit(lamina) {
		this.selectedLamina = lamina.id
		this.$bvModal.show('edit-lamina')
	}

	async addTag() {
		/*
		if (!this.formTags.tag) return
		const tag = this.options.tags.find(
			(tag) => tag.id === this.formTags.tag,
		)

		this.savingTag = true
		const res = await api.post(
			'/api/blogging/content-podcasts/' +
				this.formTags.id +
				'/content-tags',
			{ tag: this.formTags.tag },
		)
		if (res.ok) {
			this.formTags.tags.push({
				mapId: res.data.id,
				tag: {
					name: tag.name,
					id: tag.id,
				},
				loading: false,
			})
			this.formTags.tag = ''
		} else {
			this.$bvToast.toast(
				'Não foi possível associar tag, verifique se a tag já não está associada',
				{
					title: 'Erro',
					variant: 'danger',
					solid: true,
					toaster: 'b-toaster-top-center',
				},
			)
		}
		this.savingTag = false
		*/
	}

	async removeTag(tagMap, index) {
		tagMap.loading = true
		/*
		const res = await api.delete(
			'/api/blogging/content-podcasts/' +
				this.formTags.id +
				'/content-tags',
			{ mapId: tagMap.mapId },
		)
		if (res.ok) {
			this.formTags.tags.splice(index, 1)
		}
		tagMap.loading = false
		*/
	}

	mounted() {
		this.$store.dispatch('saveCurrentFullPath', this.$route.fullPath)
		this.loadContentLaminas()
		this.loadContentTags()
	}
}
